module.exports = __webpack_public_path__ + "static/media/map-marker-times.c0d1c301.svg";